import {platformMenus} from '@/router/platforms'

export const BACKSTAGE_NOTICE_UPDATED_EVENT = 'qcyy:backstage-notice-updated'

function flattenMenuItems(items = []) {
    return items.reduce((result, item) => {
        if (item.children && item.children.length) {
            return result.concat(flattenMenuItems(item.children))
        }
        return result.concat(item)
    }, [])
}

/**
 * 校验站内消息跳转目标必须是当前账号有权访问的后台路由。
 */
export function resolveAccessibleBackstageNoticePath(router, currentUser, pagePath) {
    const path = String(pagePath || '').trim()
    if (!path.startsWith('/admin/')) {
        return {allowed: false, reason: '该消息暂未配置可用的后台处理入口。'}
    }
    const resolved = router.resolve(path).route
    if (!resolved || !resolved.name || !resolved.matched || !resolved.matched.length) {
        return {allowed: false, reason: '该消息关联的后台页面不存在。'}
    }
    if (resolved.meta && resolved.meta.utilityRoute) {
        return {allowed: true, path}
    }
    const activeMenu = (resolved.meta && resolved.meta.activeMenu) || resolved.path
    const menu = flattenMenuItems(platformMenus.admin || []).find(item => item.index === activeMenu)
    if (!menu) {
        return {allowed: false, reason: '该消息关联的后台页面暂不可访问。'}
    }
    const roles = (currentUser && currentUser.roleCodes) || [currentUser && (currentUser.primaryRoleCode || currentUser.roleCode)]
    if (roles.includes('SUPER_ADMIN')) {
        return {allowed: true, path}
    }
    const permissions = new Set((currentUser && currentUser.menuPermissionCodes) || [])
    if (permissions.has('*') || permissions.has(menu.permissionCode)) {
        return {allowed: true, path}
    }
    return {allowed: false, reason: '当前账号无权访问该消息关联页面。'}
}

/** 通知顶部铃铛同步刷新未读数量。 */
export function notifyBackstageNoticeUpdated() {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(BACKSTAGE_NOTICE_UPDATED_EVENT))
    }
}
